import { getCookieChatbot } from './cookiesUtils';
import fetchBotStatus from './fetchBotStatus';

export const getBotStatus = async (chatbotStatusIsOnline, recommenderStatusIsOnline) => {
  const maintenanceModeUrl = '/api/v1/bot-status/maintenance-mode';
  
  const skipMaintenanceMode = getCookieChatbot('skipMaintenanceMode') === 'true';
  
  const response = await fetchBotStatus(maintenanceModeUrl);
  
  if (!response) {
    chatbotStatusIsOnline.value = false;
    recommenderStatusIsOnline.value = false;
    return { chatbot: false, recommender: false, skipMaintenanceMode: false };
  }
  
  if (skipMaintenanceMode) {
    chatbotStatusIsOnline.value = true;
    recommenderStatusIsOnline.value = true;
    return { 
      chatbot: true, 
      recommender: true, 
      skipMaintenanceMode: true,
      actualStatus: {
        maintenanceMode: response.maintenanceMode,
        chatbotStatus: response.chatbotStatus,
        recommenderStatus: response.recommenderStatus,
        statusValue: response.statusValue,
        recommenderValue: response.recommenderValue
      }
    };
  }
  
  const chatbotIsOnline = response.statusValue === 1;
  const recommenderIsOnline = response.recommenderValue === 1;
  
  chatbotStatusIsOnline.value = chatbotIsOnline;
  recommenderStatusIsOnline.value = recommenderIsOnline;
  
  return { 
    chatbot: chatbotIsOnline, 
    recommender: recommenderIsOnline, 
    skipMaintenanceMode: false,
    maintenanceMode: response.maintenanceMode
  };
}
